import { localize } from 'helpers/translator'
import productTypes from 'helpers/enums/productTypes'
import slideTypes from 'helpers/enums/slideTypes'
import config from 'config'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

import AudioIcon from 'assets/global/slide_icons/audio.svg'
import BBCIcon from 'assets/global/slide_icons/bbc-transparent.svg'
import CollaborateIcon from 'assets/global/slide_icons/collaborate.svg'
import DrawItIcon from 'assets/global/slide_icons/draw-it.svg'
import FieldTripIcon from 'assets/global/slide_icons/field-trip.svg'
import FillInTheBlanksIcon from 'assets/global/slide_icons/fitb.svg'
import FlocabularyIcon from 'assets/global/slide_icons/Flocabulary.svg'
import FlipgridIcon from 'assets/global/slide_icons/flipgrid.svg'
import DesmosIcon from 'assets/global/slide_icons/desmos.svg'
// import TwitterStreamIcon from 'assets/global/slide_icons/twitter-live-stream.svg'
import MemoryTestIcon from 'assets/global/slide_icons/memory-test.svg'
import Nearpod3DIcon from 'assets/global/slide_icons/3d.svg'
import PDFIcon from 'assets/global/slide_icons/pdf.svg'
import PhetIcon from 'assets/global/slide_icons/phet.svg'
// import SlideIcon from 'assets/global/slide_icons/slide.svg'
import SlideshowIcon from 'assets/global/slide_icons/slideshow.svg'
import SwayIcon from 'assets/global/slide_icons/sway.svg'
import MatchingPairsIcon from 'assets/global/slide_icons/matching-pairs.svg'
import OEQIcon from 'assets/global/slide_icons/open-ended-question.svg'
import PollIcon from 'assets/global/slide_icons/poll.svg'
import QuizIcon from 'assets/global/slide_icons/quiz.svg'
import TimeToClimbIcon from 'assets/global/slide_icons/time-to-climb.svg'
import VideoIcon from 'assets/global/slide_icons/video.svg'
import InteractiveVideoIcon from 'assets/global/slide_icons/interactive-video.svg'
import WebContentIcon from 'assets/global/slide_icons/web-content.svg'

const defaultSize = {
	width: 2000,
	height: 1500,
}

const activities = [
	{
		id: slideTypes.SLIDE_TYPE_ID_AUDIO,
		name: localize('global_slides_audio'),
		filter: '1',
		icon: AudioIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_1.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_1.png`,
		size: {
			width: 574,
			height: 580,
		},
		errorPlaceholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_1_error.png`,
		errorOverlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_1_error.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_BBC_VIDEO,
		name: localize('global_slides_bbc'),
		filter: '1',
		icon: BBCIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_2.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_2.png`,
		size: {
			width: 750,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_COLLABORATE,
		name: localize('global_slides_collaborateBoard'),
		filter: '3',
		icon: CollaborateIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_3.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_3.png`,
		size: {
			width: 800,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_DRAW_IT,
		name: localize('global_slides_drawIt'),
		filter: '3',
		icon: DrawItIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_4.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_4.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_FIELD_TRIP,
		name: localize('global_slides_fieldTrip'),
		filter: '1',
		icon: FieldTripIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_5.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_5.png`,
		size: {
			width: 913,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_FLOCABULARY,
		name: localize('global_slides_flocabulary'),
		filter: '1',
		icon: FlocabularyIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_23.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_23.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_FILL_IN_THE_BLANKS,
		name: localize('global_slides_fitb'),
		filter: '3',
		icon: FillInTheBlanksIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_6.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_6.png`,
		size: {
			width: 944,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_FLIPGRID,
		name: localize('global_slides_flipgrid'),
		filter: '3',
		icon: FlipgridIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_24.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_24.png`,
		flagType: featureFlagsTypes.FLIPGRID,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_GRAPHING_CALCULATOR,
		name: localize('global_slides_desmos'),
		filter: '3',
		icon: DesmosIcon,
		roles: [productTypes.SCHOOL],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_7.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_7.png`,
	},
	/*{
		id: slideTypes.SLIDE_TYPE_ID_LIVE_TWITTER_STREAM,
		name: localize('global_slides_twitter'),
		filter: '1',
		icon: TwitterStreamIcon,
		roles: [productTypes.GOLD, productTypes.SCHOOL, productTypes.GOLD_PLUS, productTypes.PLATINUM],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_8.png`,
		size: {
			width: 890,
			height: 1500
		}
	},*/
	{
		id: slideTypes.SLIDE_TYPE_ID_MATCHING_PAIRS,
		name: localize('global_slides_matchingPairs'),
		filter: '3',
		icon: MatchingPairsIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_9.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_9.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_MEMORY_TEST,
		name: localize('global_slides_memoryTest'),
		filter: '3',
		icon: MemoryTestIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_10.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_10.png`,
		size: {
			width: 968,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_NEARPOD_3D,
		name: localize('global_slides_nearpod3d'),
		filter: '1',
		icon: Nearpod3DIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_11.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_11.png`,
		size: {
			width: 750,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION,
		name: localize('global_slides_oeq'),
		filter: '3',
		icon: OEQIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_12.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_12.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_PDF_VIEWER,
		name: localize('global_slides_pdfViewer'),
		filter: '1',
		icon: PDFIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_13.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_13.png`,
		size: {
			width: 569,
			height: 580,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_POLL,
		name: localize('global_slides_poll'),
		filter: '3',
		icon: PollIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_14.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_14.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_QUIZ,
		name: localize('global_slides_quiz'),
		filter: '3',
		icon: QuizIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_15.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_15.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_SIMULATION,
		name: localize('global_slides_phet'),
		filter: '1',
		icon: PhetIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_16.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_16.png`,
		size: {
			width: 750,
			height: 1500,
		},
	},
	/*{
		id: slideTypes.SLIDE_TYPE_ID_SLIDE,
		name: localize('global_slides_slide'),
		filter: '1',
		icon: SlideIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_17.png`
	},*/
	{
		id: slideTypes.SLIDE_TYPE_ID_SLIDESHOW,
		name: localize('global_slides_slideshow'),
		filter: '1',
		icon: SlideshowIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_18.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_18.png`,
		size: {
			width: 890,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_SWAY,
		name: localize('global_slides_sway'),
		filter: '1',
		icon: SwayIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_19.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_19.png`,
		size: {
			width: 750,
			height: 1500,
		},
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_TIME_TO_CLIMB,
		name: localize('global_slides_timeToClimb'),
		filter: '3',
		icon: TimeToClimbIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_20.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_20.png`,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_VIDEO,
		name: localize('global_slides_video'),
		filter: '1',
		icon: VideoIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_21.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_21.png`,
		size: {
			width: 569,
			height: 1500,
		},
		errorPlaceholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_21_error.png`,
		errorOverlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_21_error.png`,
		reverseFlagType: featureFlagsTypes.INTERACTIVE_VIDEO_GOOGLE_SLIDES,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_INTERACTIVE_VIDEO,
		name: localize('global_slides_video'),
		filter: '1',
		icon: InteractiveVideoIcon,
		roles: [],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_26.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_26.png`,
		size: {
			width: 890,
			height: 1500,
		},
		flagType: featureFlagsTypes.INTERACTIVE_VIDEO_GOOGLE_SLIDES,
	},
	{
		id: slideTypes.SLIDE_TYPE_ID_WEB_CONTENT,
		name: localize('global_slides_webContent'),
		filter: '2',
		icon: WebContentIcon,
		roles: [
			productTypes.SILVER,
			productTypes.GOLD,
			productTypes.SCHOOL,
			productTypes.GOLD_PLUS,
			productTypes.PLATINUM,
		],
		placeholder: `${config.cloudfront}Images/GoogleSlides/Placeholders/activity_22.png`,
		overlay: `${config.cloudfront}Images/GoogleSlides/Overlays/activity_22.png`,
		size: {
			width: 890,
			height: 1500,
		},
	},
]

const getActivities = () => activities

export default getActivities

export const getActivitySize = activityId => {
	const activity = activities.find(activity => activity.id === activityId)
	return activity && activity.size || defaultSize
}

export const updateActivityData = (activityId, data) => {
	const activityIndex = activities.findIndex(activity => activity.id === activityId)
	activities[activityIndex] = {
		...activities[activityIndex],
		...data,
	}
	return true
}
